import Button from 'components/helpers/Button';
import { Highlight } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';

export const EmployeeHit = ({ hit }: HitProps) => {
  let phone = null;
  if (hit.phonePrimary) {
    const phoneByArr = /^([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.exec(hit.phonePrimary);
    if (phoneByArr) {
      phone = `${phoneByArr[1]}-${phoneByArr[2]}-${phoneByArr[3]}`;
    } else {
      phone = hit.phonePrimary;
    }
  }
  return (
    <div>
      <div className={classnames('mb-2')}>Employee &emsp;| &emsp;{hit.classification}</div>
      <HitHeadline hit={hit}>
        <>
          <Highlight hit={hit} attribute="firstName" />
          {` `}
          <Highlight hit={hit} attribute="lastName" />{' '}
          {hit.jobTitle ? <> - {hit.jobTitle}</> : <></>}
        </>
      </HitHeadline>
      <div className={classnames('text-body', 'mb-2')}>
        Department: {hit.department}
        &emsp;|&emsp;Reports to: {hit.manager}
      </div>
      {hit.email ? (
        <Button
          className={classnames('text-blue', 'underline', 'font-regular', 'pr-4')}
          linkField={{ value: { href: `mailto:${hit.email}`, text: hit.email } }}
          variant="link"
        />
      ) : (
        <></>
      )}
      {phone ? (
        <Button
          className={classnames('text-blue', 'underline', 'font-regular')}
          linkField={{
            value: {
              href: `tel:${phone}`,
              text: phone,
            },
          }}
          variant="link"
        />
      ) : (
        <></>
      )}
    </div>
  );
};
